export const isCategoryActive = (categories: any): boolean => {
  return categories?.some((item: any) => item.selected);
};
